import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { ContactPerson } from '../db/ContactPerson.js';

export const getContactPersonsForDebitor = registerQuery({
  operationName: 'getContactPersonsForDebitor',
  type: () => [ContactPerson],
  params: [{ name: 'debitor', type: () => String }],
  resolve: (debitor: string) => async (_gqlFields: BaseQLSelectionSet<ContactPerson>) => {
    const trimmed = debitor.trim();
    if (!trimmed) return [];

    const collection = await getRawCollection<ContactPerson>(ContactPerson._collectionName);
    const results = await collection.find({ debitor: trimmed }).sort({ partner: 1 }).toArray();
    return results.map(r => new ContactPerson(r));
  },
});
